import { AxiosResponse, AxiosError } from 'axios';
import {
    PayrollExport,
    SetPayrollExportsAction,
    RemovePayrollExportAction,
    RequestedPayrollExportsPayloadAction,
    SucceededPayrollExportsPayloadAction,
    FailedPayrollExportsPayloadAction,
    RequestedPayrollExportDeleteAction,
    SucceededPayrollExportDeleteAction,
    FailedPayrollExportDeleteAction,
    PayrollExportId
} from './types';
import {
    PAYROLL_EXPORTS_SET,
    PAYROLL_EXPORT_REMOVE,
    PAYROLL_EXPORTS_PAYLOAD_REQUESTED,
    PAYROLL_EXPORTS_PAYLOAD_SUCCEEDED,
    PAYROLL_EXPORTS_PAYLOAD_FAILED,
    PAYROLL_EXPORT_DELETE_REQUESTED,
    PAYROLL_EXPORT_DELETE_SUCCEEDED,
    PAYROLL_EXPORT_DELETE_FAILED
} from './constants';

export function setPayrollExports(
    payrollExports: PayrollExport[]
): SetPayrollExportsAction {
    return {
        type: PAYROLL_EXPORTS_SET,
        payload: payrollExports
    };
}

export function removePayrollExport(
    payrollExportId: PayrollExportId
): RemovePayrollExportAction {
    return {
        type: PAYROLL_EXPORT_REMOVE,
        payload: payrollExportId
    };
}

export function payrollExportsPayloadRequested(
    payrollExportId: number
): RequestedPayrollExportsPayloadAction {
    return {
        type: PAYROLL_EXPORTS_PAYLOAD_REQUESTED,
        payload: payrollExportId
    };
}

export function payrollExportsPayloadSucceeded(
    response: AxiosResponse
): SucceededPayrollExportsPayloadAction {
    return {
        type: PAYROLL_EXPORTS_PAYLOAD_SUCCEEDED,
        payload: response
    };
}

export function payrollExportsPayloadFailed(
    error: AxiosError
): FailedPayrollExportsPayloadAction {
    return {
        type: PAYROLL_EXPORTS_PAYLOAD_FAILED,
        payload: error,
        error: true
    };
}

export function payrollExportDeleteRequested(
    payrollExportId: number
): RequestedPayrollExportDeleteAction {
    return {
        type: PAYROLL_EXPORT_DELETE_REQUESTED,
        payload: payrollExportId
    };
}

export function payrollExportDeleteSucceeded(
    response: AxiosResponse
): SucceededPayrollExportDeleteAction {
    return {
        type: PAYROLL_EXPORT_DELETE_SUCCEEDED,
        payload: response
    };
}

export function payrollExportDeleteFailed(
    error: AxiosError
): FailedPayrollExportDeleteAction {
    return {
        type: PAYROLL_EXPORT_DELETE_FAILED,
        payload: error,
        error: true
    };
}
